//add all color constants here

export const colorConstants = {
    violet: '#44338A',
    darkGrey: '#807E86',
    grey: '#F7F5FF',
    orange: '#F1AD32',
    orangeAlt: '#E8A122',
    orangeAlt2: '#E6875E',
    orangeAlt3: '#ECA586',
    darkOrange: '#E06936',
    darkBlue: '#2F45DE',
    lightBlue: '#37C7BE',
    limeGreen: '#42A531',
    limeGreenAlt2: '#52C41A',
    limeAlt: '#87DED8',
    lightGreen: '#BBF1B0',
    lightGreenAlt: '#69D4E8',
    lightGreenAlt2: '#7ED957',
    darkGreen: '#759B25',
    darkGreenAlt: '#00798C',
    darkGreenAlt2: '#3394A3',
    red: '#CA3D3D',
    lightRed: '#FF9C9C',
    darkRed: '#B62548',
    greyAlt: '#D9D9D9',
    borderGrey: '#D7D6D9',
    lightBlack: '#433C4A',
    cream: '#FBE6BF',
    blackAlt: '#140B1D',
    purple: '#9E5897',
    darkBlueAlt: '#293BB8',
    pink: '#DD449F',
    pinkAlt: '#E469B2',
    pinkAlt2: '#EB8FC5',
    brown: '#A5582D',
    lightGrey: '#D8D8D8',
    fontGrey: '#4E4C55',
    borderGreyAlt: '#EAEAEC',
    cyan: '#43C9E2',
    blue: '#19669D',
    lightCyan: '#A0DBD8',
    lightCream: '#F2C77DB2',
    lightPink: '#EA87C2B2',
    lightOrange: '#DF8157B2',
    darkCyan: '#85B0B7B2',
    darkViolet: '#E6E0FF',
    limeGreenAlt: '#D2F4CB',
    lightRedAlt: '#FFCBCB',
    lightPurple: '#FAFAFC',
    white: '#FFFFFF',
    darkYellow: '#EDB44E',
    violetAlt: '#826FD0',
    greyAlt2: '#E6E6EA',
    greyAlt3: '#DBDFE9',
    greyAlt1: '#F4F3F5',
    greyAlt4: '#ACAAB0',
    fontGreyAlt: '#A49FA9',
    lightGreyAlt: '#f6f6f9',
    purpleFont: '#44328a',
    violetAlt1: '#BAB1E2',
    bestWeeksDarkRed1: '#D56464',
    bestWeeksDarkRed2: '#E59E9E',
    bestWeeksDarkRed3: '#F4D8D8',
    bestWeeksDarkGreen3: '#D9EDD6',
    bestWeeksDarkGreen2: '#A1D298',
    bestWeeksDarkGreen1: '#68B75A',
    lightBlueAlt: '#AFE9E5',
    greyAlt5: '#E0DEE2',
    greyAlt6: '#F0F0F0',
    greyAlt7: '#000000a6',
    greyAlt8: '#2b08491a',
    greyAlt9: '#FAFAFA',
    greyAlt10: '#e4ebf780',
    greyAlt11: '#E4EBF7',
    greyAlt12: '#00000040',
    greyAlt13: '#f0f0f080',
    greyAlt14: '#00000073',
    greyAlt15: '#8c8c8c',
    greyAlt16: '#0000000f',
    greyAlt17: '#bfbfbf',
    greyAlt18: '#0000008A',
    lightGreenAlt1: '#5FD3CB',
    greenALt1: '#95DE64',
    limeGreenAlt1: '#B7EB8F',
    darkGreenAlt3: '#228BD6',
    purpleAlt: '#B377AD',
    orangeAlt1: '#CC7442',
    violetAlt2: '#55A8E4',
    violetAlt3: '#7381E0',
    purpleAlt1: '#C699C2',
    yellow: '#F1C77A',
    yellowAlt: '#FFD666',
    blackAlt1: '#000000e0',
    blueAlt: '#648BD8',
    blueAlt1: '#0958D9',
    blueAlt2: '#4096FF',
    blueAlt3: '#1677FF',
    blueAlt5: '#0591ffb3',
    blueAlt4: '#58D1C9',
    redAlt: '#FF4D4F',
    redAlt1: '#FF7875',
    lightGreen1: '#F6FFED',
    lightYellow1: '#FFFBE6',
    lightBlue1: '#EBFCFF',
    lightOrangeAlt: '#FF9C6E',
    lightPurpleAlt: '#85A5FF',
};
